module.exports = __webpack_public_path__ + "img/mielopolis-logo-v3.9a372277.png";